"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withSpace = exports.getSpaceProps = exports.makeConstruct = void 0;
var tslib_1 = require("tslib");
var ui_symbols_1 = require("@hopin-team/ui-symbols");
var polished_1 = require("polished");
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
/**
 * Breakpoints with mobile-first approach: default + over 40em, over 52em, over
 * 64em, over 80em.
 */
var BREAKPOINTS = [40, 52, 64, 80];
/**
 * Creates a function that returns CSS styles of margin and padding space.
 * @param property margin or padding.
 * @param step of vertical rhythm.
 * @param direction where to apply space.
 * @param absolute whether the space is a number of steps or an absolute number
 * of pixels.
 */
var makeConstruct = function (property, step, direction, absolute) {
    return function (value) {
        if (value === undefined) {
            return '';
        }
        var space;
        if (value === 'auto') {
            space = 'auto';
        }
        else if (absolute) {
            space = (0, polished_1.rem)(value);
        }
        else {
            space = (0, ui_symbols_1.calcSpace)(value, step);
        }
        var css = {
            t: "".concat(property, "-top: ").concat(space),
            b: "".concat(property, "-bottom: ").concat(space),
            r: "".concat(property, "-right: ").concat(space),
            l: "".concat(property, "-left: ").concat(space),
        };
        switch (direction) {
            case 'x': {
                return "\n        ".concat(css.l, ";\n        ").concat(css.r, ";\n      ");
            }
            case 'y': {
                return "\n        ".concat(css.t, ";\n        ").concat(css.b, ";\n      ");
            }
            case 't':
            case 'b':
            case 'l':
            case 'r': {
                return "\n        ".concat(css[direction], ";\n      ");
            }
            default: {
                return "\n        ".concat(property, ": ").concat(space, ";\n      ");
            }
        }
    };
};
exports.makeConstruct = makeConstruct;
/**
 * Creates responsive space styles for each breakpoint when the value passed is
 * an array.
 */
var makeResponsiveStyles = function (_a) {
    var construct = _a.construct, value = _a.value, breakpoints = _a.breakpoints;
    var makeBreakpointStyles = function (value, i) { return "\n    @media (min-width: ".concat(breakpoints[i], "em) {\n      ").concat(construct(value), "\n    }\n  "); };
    var _b = tslib_1.__read(value.slice(0, breakpoints.length + 1)), base = _b[0], responsive = _b.slice(1);
    var styles = "\n    ".concat(construct(base), "\n    ").concat(responsive
        .map(function (value, i) { return makeBreakpointStyles(value, i); })
        .join(' '), "\n  ");
    return styles;
};
/**
 * Creates space styles from a props.
 * @param property margin or padding.
 * @param step of vertical rhythm.
 * @param direction where to apply space.
 * @param value how much space to apply.
 * @param spaceOptions configuring the space.
 */
var makeSpaceStyles = function (property, value, step, direction, spaceOptions) {
    var _a = spaceOptions, _b = _a.absolute, absolute = _b === void 0 ? false : _b, _c = _a.breakpoints, breakpoints = _c === void 0 ? BREAKPOINTS : _c;
    var construct = (0, exports.makeConstruct)(property, step, direction, absolute);
    if (typeof value === 'string' || typeof value === 'number') {
        return construct(value);
    }
    // Responsive space
    if (Array.isArray(value)) {
        return makeResponsiveStyles({ construct: construct, value: value, breakpoints: breakpoints });
    }
    return '';
};
/**
 * Filters the props object for space props and concatenates the final styles
 * from all found space props into one string.
 */
var getSpaceProps = function (_a) {
    var _b = _a.spaceOptions, spaceOptions = _b === void 0 ? {} : _b, props = tslib_1.__rest(_a, ["spaceOptions"]);
    var step = ui_symbols_1.SCALE.STEP;
    var margins = "";
    var paddings = "";
    Object.keys(props).forEach(function (key) {
        var match = key.match(/^([p|m])(x|y|t|b|l|r){0,1}$/);
        if (match) {
            var value = props[key];
            match[1] === 'm'
                ? (margins =
                    margins +
                        makeSpaceStyles('margin', value, step, match[2], spaceOptions))
                : (paddings =
                    paddings +
                        makeSpaceStyles('padding', value, step, match[2], spaceOptions));
        }
    });
    return "\n    ".concat(margins, "\n    ").concat(paddings, "\n  ");
};
exports.getSpaceProps = getSpaceProps;
function withSpace(Component) {
    var WrappedComponent = (0, styled_components_1.default)(Component)(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n    ", "\n  "], ["\n    ", "\n  "])), function (props) { return (0, exports.getSpaceProps)(props); });
    // Reset the displayName
    // So you avoid "Styled(MyComponent)"
    // Also helps prevent <MyComponentWithSpace /> in Storybook
    WrappedComponent.displayName =
        Component.displayName || Component.name || WrappedComponent.displayName;
    return WrappedComponent;
}
exports.withSpace = withSpace;
var templateObject_1;
//# sourceMappingURL=index.js.map